import {useState} from "react"

export const useFavorites = () => {
	const [favorites, setFavorites] = useState<string[]>(() => {
		try {
			return JSON.parse(localStorage.getItem("deviceFavorites") || "[]")
		} catch {
			return []
		}
	})

	const toggleFavorite = (deviceId: string) => {
		setFavorites((prev) => {
			const next = prev.includes(deviceId)
				? prev.filter((id) => id !== deviceId)
				: [...prev, deviceId]
			localStorage.setItem("deviceFavorites", JSON.stringify(next))
			return next
		})
	}

	const addFavorites = (deviceIds: string[]) => {
		setFavorites((prev) => {
			const next = Array.from(new Set([...prev, ...deviceIds]))
			localStorage.setItem("deviceFavorites", JSON.stringify(next))
			return next
		})
	}

	const removeFavorites = (deviceIds: string[]) => {
		setFavorites((prev) => {
			const next = prev.filter((id) => !deviceIds.includes(id))
			localStorage.setItem("deviceFavorites", JSON.stringify(next))
			return next
		})
	}

	return {favorites, toggleFavorite, addFavorites, removeFavorites}
}
